import { render } from "./cu-tabbar.vue?vue&type=template&id=6ae34ca8&scoped=true"
import script from "./cu-tabbar.vue?vue&type=script&lang=js"
export * from "./cu-tabbar.vue?vue&type=script&lang=js"

import "./cu-tabbar.vue?vue&type=style&index=0&id=6ae34ca8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ae34ca8"]])

export default __exports__